import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { observer } from 'mobx-react'
import {
  Nav,
  NavItem
} from 'react-bootstrap'

import Header from './header'
import SideMenuItem from './sidemenuitem'

@observer(['companies', 'globals'])
export default class Menu extends Component {

  constructor(props) {
    super(props);
    let isRestricted = localStorage.getItem('userId') === "30";
    this.state = {
      showMenu: true,
      ristrictedUser: isRestricted ? isRestricted : false,
      active: 1
    }

    this.props.companies.countNewlyAssignedLeads()
  }

  handleMainNavSelect(e) {
    switch(e) {
      case '1':
        browserHistory.push('/')
        break
      case '2':
        browserHistory.push('/reports')
        break
      case '3':
        browserHistory.push('/inventory')
        break
      default:
        browserHistory.push('/')
    }
  }

  handleCompanyNavSelect(e) {
    switch(e) {
      /*
      case '1':
        browserHistory.push('/customers')
        break
      case '2':
        browserHistory.push('/contacts')
        break
      case '3':
        browserHistory.push('/leads')
        break
      case '4':
        browserHistory.push('/inactive')
        break
      */
      case '1':
        browserHistory.push('/companies')
        break
      case '2':
        browserHistory.push('/tasks')
        break
      /*
      case '3':
        browserHistory.push('/quotes')
        break
      case '4':
        browserHistory.push('/orders')
        break
      */
      case '3':
        browserHistory.push('/invoices')
        break
      default:
        browserHistory.push('/')
    }
  }

  handlePartnerNavSelect(e) {
    switch(e) {
      case '1':
        browserHistory.push('/partners')
        break
      case '2':
        browserHistory.push('/partnertasks')
        break
      default:
        browserHistory.push('/')
    }
  }

  handleAdminNavSelect(e) {
    switch(e) {
      /*
      case '1':
        browserHistory.push('/admin/imports')
        break
      */
      case '1':
        browserHistory.push('/admin/organizations')
        break
      /*
      case '2':
        browserHistory.push('/admin/permissions')
        break
      */
      case '2':
        browserHistory.push('/admin/siteoptions')
        break
      case '3':
        browserHistory.push('/admin/users')
        break
      /*
      case '4':
        window.open('https://gps-leaders.myshopify.com/','_blank');
        break
      */
      case '5':
        browserHistory.push('/assetmanager');
        break;
      default:
        browserHistory.push('/admin')
    }
  }

  toggleMenu(e) {
    this.setState({
      showMenu: !this.state.showMenu
    })
  }

  logout(e) {
    this.props.globals.logout()
  }

  render() {

    let accessLevel = localStorage.getItem('userAccessLevel')

    let adminMenu = ''

    if (accessLevel >= 10) {
      let adminMenuItems = ''

      if (accessLevel >= 15){
          adminMenuItems = (
            <Nav stacked bsStyle="pills" onSelect={ this.handleAdminNavSelect }>
              { /* <NavItem eventKey="1"><SideMenuItem classNames="fa fa-upload" name="Imports" /></NavItem> */ }
              <NavItem eventKey="1"><SideMenuItem classNames="fa fa-building-o" name="Organizations" /></NavItem>
              { /*<NavItem eventKey="2"><SideMenuItem classNames="fa fa-check-square-o" name="Permissions" /></NavItem> */ }
              <NavItem eventKey="2"><SideMenuItem classNames="fa fa-list-alt" name="Site Options" /></NavItem>
              <NavItem eventKey="3"><SideMenuItem classNames="fa fa-users" name="Users" /></NavItem>
              { /* <NavItem eventKey="4"><SideMenuItem classNames="fa fa-usd" name="Shopify" /></NavItem> */ }
              <NavItem eventKey="5"><SideMenuItem classNames="fa fa-server" name="Asset Manager" /></NavItem>
            </Nav>
          )
      } else {
        adminMenuItems = (
          <Nav stacked bsStyle="pills" onSelect={ this.handleAdminNavSelect }>
            <NavItem eventKey="4"><SideMenuItem classNames="fa fa-users" name="Users" /></NavItem>
            <NavItem eventKey="5"><SideMenuItem classNames="fa fa-server" name="Asset Manager" /></NavItem>
          </Nav>
        )
      }

      adminMenu = (
        <div className="menu_section">
          <h3>Admin</h3>
          <ul className="nav side-menu">
            { adminMenuItems }
          </ul>
        </div>
      )
    }

    

    return (
      <div className="col-md-3 left_col open">
        <div className="left_col scroll-view">
          <Header className="hidden-sm" />
          <div className="clearfix"></div>
          <div className="profile clearfix">
            <div className="profile_info" style={{ textAlign: 'center' }}>
              <h2>{ this.props.globals.loggedInUser.firstName } { this.props.globals.loggedInUser.lastName }</h2>
            </div>
          </div>
          <br />
          <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
            <div className="menu_section">
              <h3>Main</h3>
              <ul className="nav side-menu">
                <Nav stacked bsStyle="pills" onSelect={ this.handleMainNavSelect }>
                  <NavItem eventKey="1"><SideMenuItem classNames="fa fa-home" name={ "Dashboard (" + this.props.companies.newlyAssignedLeadsCount + ")" } /></NavItem>
                  <NavItem eventKey="2"><SideMenuItem classNames="fa fa-file-text-o" name="Reports" /></NavItem>
                  <NavItem eventKey="3"><SideMenuItem classNames="fa fa-home" name="Inventory" /></NavItem>
                </Nav>
              </ul>
            </div>
            <div className="menu_section">
              <h3>Companies</h3>
              <ul className="nav side-menu">
                <Nav stacked bsStyle="pills" onSelect={ this.handleCompanyNavSelect }>
                  { /*
                  <NavItem eventKey="1"><SideMenuItem classNames="fa fa-globe" name="Customers" /></NavItem>
                  <NavItem eventKey="2"><SideMenuItem classNames="fa fa-globe" name="Contacts" /></NavItem>
                  <NavItem eventKey="3"><SideMenuItem classNames="fa fa-globe" name="Leads" /></NavItem>
                  <NavItem eventKey="4"><SideMenuItem classNames="fa fa-globe" name="Inactive" /></NavItem>
                  */ }
                  <NavItem eventKey="1"><SideMenuItem classNames="fa fa-globe" name="Companies" aria-hidden="true" /></NavItem>
                  <NavItem eventKey="2"><SideMenuItem classNames="fa fa-tasks" name="Tasks" aria-hidden="true" /></NavItem>
                  { /*
                  <NavItem eventKey="3"><SideMenuItem classNames="fa fa-paperclip" name="Quotes" /></NavItem>
                  <NavItem eventKey="4"><SideMenuItem classNames="fa fa-usd" name="Orders" /></NavItem>
                  */ }
                  {localStorage.getItem('userId') === "30" ? null : <NavItem eventKey="3"><SideMenuItem classNames="fa fa-usd" name="Invoices" /></NavItem>}
                </Nav>
              </ul>
            </div>
            <div className="menu_section">
              <h3>Partners</h3>
              <ul className="nav side-menu">
                <Nav stacked bsStyle="pills" onSelect={ this.handlePartnerNavSelect }>
                  {localStorage.getItem('userId') === "30" ? null : <NavItem eventKey="1"><SideMenuItem classNames="fa fa-balance-scale" name="Partners" aria-hidden="true" /></NavItem>}
                  <NavItem eventKey="2"><SideMenuItem classNames="fa fa-tasks" name="Tasks" aria-hidden="true" /></NavItem>
                </Nav>
              </ul>
            </div>
            { adminMenu }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/menu.js